import projectoverview from "../../../../assets/images/docs/projects/selector.png";
import bookmarksoverview from "../../../../assets/images/docs/projects/bookmarks.png";
import addproject from "../../../../assets/images/docs/projects/addproject.png";
import projecticon from "../../../../assets/images/docs/projects/icon.png";
import projectbookmarks from "../../../../assets/images/docs/projects/addbookmark.png";
import addenvironment from "../../../../assets/images/docs/projects/addenvironment.png";
import environments from "../../../../assets/images/docs/projects/environments.png";
import sortprojects from "../../../../assets/videos/blogs/pp28/sortprojects.mp4";
import sortbookmarks from "../../../../assets/videos/blogs/pp28/sortbookmarks.mp4";
import defaultnewprojecttab from "../../../../assets/images/blogs/pp30/defaultnewprojecttab.png";
import * as React from 'react';
export default {
  projectoverview,
  bookmarksoverview,
  addproject,
  projecticon,
  projectbookmarks,
  addenvironment,
  environments,
  sortprojects,
  sortbookmarks,
  defaultnewprojecttab,
  React
};